import React, { useEffect } from "react";
import { Container, Row, Col, Card, ProgressBar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faTruck, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Services.css";

import ms1  from "../assets/images/manufacture & supply-1.jpg";
import ms2  from "../assets/images/manufacture & supply-2.jpg";
import ms3  from "../assets/images/manufact & supply-3.jpg";
import ipm1 from "../assets/images/ipm-1.jpg";
import ipm2 from "../assets/images/ipm-2.webp";
import ipm3 from "../assets/images/ipm-3.webp";
import ipm4 from "../assets/images/ipm-4.jpg";
import ipm5 from "../assets/images/ipm-5.jpg";
import ipm6 from "../assets/images/ipm-6.jpg";
import IndustrialPackagingSupply from "../assets/images/IndustrialPackagingSupply.jpg";
import StrappingLashing from "../assets/images/StrappingLashing.jpg";
import BoxesPalletsBoards from "../assets/images/BoxesPalletsBoards.jpg"

import {
  FaCogs, FaDraftingCompass, FaPaintRoller, FaCut,
  FaBarcode, FaRulerCombined, FaTools, FaClipboardCheck,
  FaWrench, FaIndustry,
} from "react-icons/fa";

const manufacturing = [
  { icon: <FaDraftingCompass />, title: "Stretch Film Supply",    desc: "High-quality stretch films for pallet wrapping and product protection during transit." },
  { icon: <FaPaintRoller />,    title: "Protective Packaging",   desc: "Air bubble rolls, foam sheets, and protective sleeves for safe transit of goods." },
  { icon: <FaCogs />,           title: "Dunnage Air Bags",       desc: "Inflatable dunnage bags to prevent cargo movement and damage during transport." },
  { icon: <FaCut />,            title: "Tape Solutions",         desc: "BOPP tape, printed tape, floor marking tape, duck tape, and specialty tapes." },
  { icon: <FaBarcode />,        title: "Strapping Solutions",    desc: "PP strap, PET strap, composite cord strap, and box strapping machines." },
  { icon: <FaRulerCombined />,  title: "Lashing & Cargo Belts",  desc: "Ratchet belts, cargo lashing belts, and truck lashing straps for secure loads." },
  { icon: <FaTools />,          title: "Angle & Edge Board",     desc: "Corner protection boards for safe stacking and shipping of products." },
  { icon: <FaClipboardCheck />, title: "Boxes & Pallets",        desc: "Corrugated boxes, wooden boxes, FLC box pallets for storage and dispatch." },
];

const Services = () => {
  useEffect(() => { AOS.init({ duration: 900, once: true }); }, []);

  return (
    <div className="services-page">

      {/* ── PAGE HERO ── */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 data-aos="fade-up">Our Services</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            End-to-end industrial packaging solutions for manufacturing industries across Pune
          </p>
        </div>
      </div>

      {/* ── WHAT WE OFFER ── */}
      <section className="core-services-section">
        <Container>
          <h2 className="rotating-yellow-text text-center" data-aos="fade-up">What We Offer</h2>
          <p className="section-sub" data-aos="fade-up">Comprehensive packaging solutions for every industrial need</p>
          <Row className="mt-4 justify-content-center">
            {[
              { icon: faBoxOpen,    title: "Industrial Packaging Supply",   desc: "Complete range of packaging materials including stretch films, bubble rolls, foam sheets, silica gel, and dunnage air bags.", img: IndustrialPackagingSupply },
              { icon: faTruck,      title: "Strapping & Lashing Solutions", desc: "PP strap, PET strap, composite cord strap, ratchet belt, cargo lashing belt, and truck lashing straps for secure cargo handling.", img: StrappingLashing },
              { icon: faLayerGroup, title: "Boxes, Pallets & Boards",       desc: "Corrugated boxes, wooden boxes, FLC box pallets, PP sheets, PP boxes, angle boards, and edge boards for complete packaging needs.", img: BoxesPalletsBoards },
            ].map((s, i) => (
              <Col md={4} className="mb-4" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="core-service-box">
                  <div className="csb-img">
                    <img src={s.img} alt={s.title} />
                    <div className="csb-img-overlay">
                      <div className="csb-icon"><FontAwesomeIcon icon={s.icon} /></div>
                    </div>
                  </div>
                  <div className="csb-body">
                    <h4>{s.title}</h4>
                    <p>{s.desc}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── IMAGE STRIP 1 ── */}
      <section className="img-strip-section">
        <div className="img-strip-grid">
          {[ms1, ms2, ms3, ipm2, ipm3, ipm4].map((img, i) => (
            <div className="img-strip-item" key={i}>
              <img src={img} alt={`packaging-${i + 1}`} />
              <div className="img-strip-overlay" />
            </div>
          ))}
        </div>
      </section>

      {/* ── OUR SUPPLY PROCESS ── */}
      <section className="supply-process-section">
        <Container>
          <h2 className="rotating-yellow-text text-center" data-aos="fade-up">Our Supply Process</h2>
          <p className="section-sub" data-aos="fade-up">8 key services we provide to our industrial clients</p>
          <div className="supply-process-grid mt-4">
            {manufacturing.map((service, index) => (
              <div key={index} className="sp-card" data-aos="fade-up" data-aos-delay={(index % 4) * 80}>
                <div className="sp-icon">{service.icon}</div>
                <h3 className="sp-title">{service.title}</h3>
                <p className="sp-desc">{service.desc}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* ── HOW WE WORK ── */}
      <section className="how-we-work">
        <Container>
          <h2 className="rotating-yellow-text text-center" data-aos="fade-up">How We Work</h2>
          <p className="section-sub" data-aos="fade-up">Our simple 3-step process to serve you better</p>
          <Row className="mt-4 justify-content-center">
            {[
              { icon: <FaCogs />,     step: "01", title: "Requirement Assessment",   desc: "We understand your packaging requirements and recommend the right materials for your industry and product type." },
              { icon: <FaIndustry />, step: "02", title: "Sourcing & Manufacturing", desc: "We source and manufacture high-quality packaging materials meeting industrial standards with consistent quality." },
              { icon: <FaWrench />,   step: "03", title: "Timely Delivery",          desc: "We ensure on-time delivery of all packaging materials to your facility with proper documentation and support." },
            ].map((w, i) => (
              <Col md={4} className="mb-4" key={i} data-aos="fade-up" data-aos-delay={i * 120}>
                <div className="work-step-card">
                  <div className="ws-step-num">{w.step}</div>
                  <div className="ws-icon">{w.icon}</div>
                  <h3>{w.title}</h3>
                  <p>{w.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="testimonials-section">
        <Container>
          <h2 className="rotating-yellow-text text-center" data-aos="fade-up">What Our Clients Say</h2>
          <p className="section-sub testi-sub" data-aos="fade-up">Trusted by 500+ industries across Pune and India</p>
          <Row className="mt-4">
            {[
              { text: '"Anvika Industrial Supplier has been our go-to for stretch films and strapping. Consistent quality and always on time."', name: "Rajesh Patil", company: "Manufacturing Unit, Chakan" },
              { text: '"Excellent range of packaging products. Their dunnage air bags and lashing belts are top quality. Highly recommended."', name: "Suresh Jadhav", company: "Logistics Company, Pune" },
              { text: '"Best supplier for corrugated boxes and PP straps in Pune. Reliable, affordable, and professional service."', name: "Amit Sharma", company: "Export Firm, Moshi" },
            ].map((t, i) => (
              <Col md={4} className="mb-4" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                <Card className="testimonial-card">
                  <Card.Body>
                    <div className="testi-quote">"</div>
                    <p>{t.text.replace(/^"|"$/g, '')}</p>
                    <div className="testi-author">
                      <div className="testi-avatar">{t.name[0]}</div>
                      <div>
                        <h5>{t.name}</h5>
                        <span>{t.company}</span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── SERVICE QUALITY ── */}
      <section className="service-quality-section">
        <Container>
          <Row className="align-items-center">
            <Col md={5} data-aos="fade-right">
              <h2 className="rotating-yellow-text">Our Service Quality</h2>
              <p style={{ color: '#4A7FA7', fontFamily: 'Poppins', fontSize: '0.95rem', marginTop: '10px' }}>
                We consistently deliver excellence across all our service parameters — from product quality to on-time delivery.
              </p>
            </Col>
            <Col md={7} data-aos="fade-left">
              <div className="quality-bars mt-3">
                {[
                  { title: "On-Time Delivery",       percentage: 97 },
                  { title: "Product Quality",         percentage: 95 },
                  { title: "Customer Satisfaction",   percentage: 99 },
                  { title: "Order Fulfillment Rate",  percentage: 98 },
                ].map((s, i) => (
                  <div key={i} className="progress-section">
                    <h5>{s.title} <span>{s.percentage}%</span></h5>
                    <ProgressBar now={s.percentage} />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default Services;
